<style>
.el-table .selected-row {
  background: #dbdbdb;
  font-weight: bold;
  color: #009ef7;
}

.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm,
.container {
  max-width: 100%;
}

.card .card-body {
  padding: 1rem;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

.el-input-number__decrease{
  visibility: hidden;
}

.el-input-number__increase{
  visibility: hidden;
}

input[type="number"] {
    -moz-appearance:textfield; /* Firefox */
}

#textRight .el-input__inner{
  text-align: right !important;
}

.el-input-number.is-controls-right .el-input__inner{
  padding-left: 0px;
  padding-right: 0px;
  height: 40px;
}

.el-input.is-disabled .el-input__inner{
  color: #0032ff;
}

.divCountTotal{
  width: 60px; 
  height: 40px;
  text-align: center;
  color: #0032ff;
  background-color: #f5f7fa;
  border: 1px solid;
  border-color: #e4e7ed;
  cursor: not-allowed;
  border-radius: 3px;
  font-size: 16px;
  padding: 7px;
}

.divSumTotal{
  width: 120px; 
  height: 40px;
  text-align: right;
  color: #0032ff;
  background-color: #f5f7fa;
  border: 1px solid;
  border-color: #e4e7ed;
  cursor: not-allowed;
  border-radius: 3px;
  font-size: 16px;
  padding: 7px;
}

</style>

<template>
  <div class="card">
    <div class="card-header" style="min-height: 50px; padding: 0 1.25rem">
      <div class="card-title">
        <!-- &nbsp;<button
          class="btn btn-icon btn-primary"
          style="height: 40px"
          @click="getHeadData()"
        >
          <span class="fa fa-search"></span>
        </button> --> 
        <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
        <!-- <el-date-picker
          v-model="SelectedMonthValue"
          type="monthrange"
          unlink-panels
          range-separator=":"
          start-placeholder="เดือนที่เริ่ม"
          end-placeholder="เดือนที่สิ้นสุด"
          :shortcuts="shortcuts"
          format="MM/YYYY"
          style="width: 250px"
          @change="getSellOrderReportHeadByDate"
        >
        </el-date-picker>      -->
        <date-time-picker-with-option 
          style="max-width: 235px"  
          v-model="filter.dateRange"
          :clearable="false"
          @change="getSellOrderReportHeadByDate">
        </date-time-picker-with-option>               
        &nbsp;&nbsp;
        <el-radio-group v-model="filter.status" @change="getSellOrderReportHead">
          <el-radio-button v-for="s in status" :key="s.value" :label="s.name"></el-radio-button>
        </el-radio-group>   
        &nbsp;&nbsp;
        <role-view :roles="['admin']">
          <el-select 
            v-model="filter.partnerCode" 
            placeholder="เลือกพาร์ทเนอร์"
            :loading="searchingPartner"
            clearable
            filterable
            style="max-width: 200px" 
            @change="getSellOrderReportHead">
            <el-option
              v-for="partnerOption in arrPartnerOption"
              :key="partnerOption.partnerCode"
              :label="partnerOption.partnerName"
              :value="partnerOption.partnerCode"                
            >
              <span style="float: left">{{ partnerOption.partnerCode }}</span>
              <span
                style="
                  float: right;
                  color: var(--el-text-color-secondary);"
                >{{ partnerOption.partnerName }}</span
              >
            </el-option>
          </el-select>  
        &nbsp;&nbsp;
        </role-view>

        <download-excel
          :class     = "btnExcelClass"
          :style    = "btnExcelStyle"
          :data     = "sellreportHead"
          :name     = "excelFileName"
          :meta     = "excelMeta"
          :param    = "excelParam"
          :columnName = "excelColumnName"
          :titleSheet = "excelTitleSheet">
          <i class="fa fa-file-excel"></i> Excel
        </download-excel>        
      </div>
      <div class="card-toolbar">
        <role-view :roles="['admin']">
        <el-checkbox v-model="isPayFilter" label="ช่วงวันที่ชำระ" @change="getSellOrderReportHeadByDate" :disabled="isCheckDisabled"></el-checkbox>&nbsp;
        <!-- <label style="color: #909399; font-weight: bold;">ช่วงวันที่ชำระ</label>  -->
        <date-time-picker-with-option 
          style="max-width: 225px"  
          v-model="filter.payDateRange"
          :clearable="false"
          :disabled="!isPayFilter"
          @change="getSellOrderReportHeadByDate">
        </date-time-picker-with-option>    
        </role-view>           
        <role-view :roles="['user', 'manager', 'owner']">
          <div class="divCountTotal">{{ multipleSelection.length }}</div>&nbsp;<span style="font-weight: bold; color: #606266;">รายการ&nbsp;&nbsp;|&nbsp;&nbsp;จำนวนที่ต้องชำระ</span>&nbsp;
          <div class="divSumTotal">{{ numberWithCommas(showDueTotal) }}</div>&nbsp;<span style="font-weight: bold; color: #606266;">บาท</span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button
            type="button"
            class="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#kt_modal_add_customer"
            @click="callOverdueItems"
            :disabled="multipleSelection.length == 0"
          >
            ชำระเงิน
          </button>  
        </role-view>      
      </div>      
    </div>
    <div class="card-body">
      <div class="row">
        <!-- <div class="col-2">
          <el-table
            :data="sellreportHead"
            border
            :height="windowHeight"
            :summary-method="getSummaryHead"
            show-summary
            style="width: 100%; cursor: pointer"
            @row-click="handleSelectionChangeHead"
            :row-class-name="SelectedRowClassName"
            v-loading="loadingHead"
            element-loading-text="Loading"
            element-loading-spinner="el-icon-loading"
            :cell-style="{ padding: '0', height: '45px' }"
          >
            <el-table-column
              prop="columnKey"
              label="สัปดาห์ที่"
              width="105"
              align="center"
              sortable
            >
            </el-table-column>
            <el-table-column prop="column1" label="ขาย" align="right" sortable>
              <template v-slot="scope">
                {{
                  Number(
                    parseFloat(scope.row.column1).toFixed(2)
                  ).toLocaleString()
                }}
              </template>
            </el-table-column>
            <el-table-column prop="column2" label="ทุน" align="right" sortable>
              <template v-slot="scope">
                {{
                  Number(
                    parseFloat(scope.row.column2).toFixed(2)
                  ).toLocaleString()
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="column3"
              label="สถานะ"
              align="center"
              width="90"
              sortable
            >
              <template v-slot="scope">
                <status :statustype="scope.row.column3"></status>
              </template>
            </el-table-column>
          </el-table>
        </div> -->
        <div class="col-12">
          <el-table
            ref="multipleTable"
            :data="sellreportHead"
            border
            :height="windowHeight"
            :summary-method="getSummaryDetail"
            show-summary
            v-loading="loadingHead"
            element-loading-text="Loading"
            element-loading-spinner="el-icon-loading"
            style="width: 100%;"
            :cell-style="{ padding: '0', height: '45px' }"
            @selection-change="handleSelectionChange"      
            @row-click="setDataTolocalStorage"
          >         
            <el-table-column prop="isCode" label="ใบกำกับภาษี" width="140">
              <template v-slot="scope">
                <div  v-if="scope.row.orderCode.startsWith('Q')">
                  <!-- <router-link
                    :to="{name: 'SellRequestDetail', params: {srCode: scope.row.orderCode,fromOverDue:true}}">
                      <span class="fw-bolder text-primary" > {{scope.row.isCode }}</span>
                  </router-link> -->
                  <router-link
                    v-if="isAdmin"
                    :to="{name: 'partnerSellRequestDetail', params: {partnerCode: scope.row.partnerCode,srCode: scope.row.orderCode,fromOverDue:true}}">
                    <span class="fw-bolder text-primary" > {{scope.row.isCode }}</span>
                  </router-link>
                  <router-link v-else
                    :to="{name: 'SellRequestDetail', params: {srCode: scope.row.orderCode,fromOverDue:true}}">
                      <span class="fw-bolder text-primary" > {{scope.row.isCode }}</span>
                  </router-link>             
                  <br>                
                  <span>{{ scope.row.orderCode}}</span>
                </div>
                <div v-else>
                  <router-link
                    v-if="isAdmin"
                    :to="{name: 'partnerOrderDetail', params: {partnerCode: scope.row.partnerCode, orderCode: scope.row.orderCode,fromOverDue:true}}">
                    <span class="fw-bolder text-primary" > {{scope.row.orderCode }}</span>
                  </router-link>
                  <router-link
                    v-else
                    :to="{name: 'orderDetail', params: {orderCode: scope.row.orderCode,fromOverDue:true}}">
                    <span class="fw-bolder text-primary" > {{scope.row.orderCode }}</span>
                  </router-link>
                  <br>                
                  <span>{{ scope.row.isCode }}</span>
                  <br>
                </div>
                <span style="font-size: 12px; color: #a1a5b7">{{ formatDateFromISO(scope.row.iS_Date) }}</span> &nbsp;&nbsp;
                <span v-if="scope.row.isQT" class="fw-bolder" style="font-size: 12px; color: #7e8299;  font-weight: 800 !important;"> [QT]</span>
              </template>
            </el-table-column>          
            <!-- <el-table-column prop="is_Date" label="วันที่" width="100">
              <template v-slot="scope">
                <span>{{ formatDateFromISO(scope.row.iS_Date) }}</span>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="isWeight"
              label="น้ำหนัก"
              align="right"
              width="90"
            >
              <template v-slot="scope">
                <span v-if="scope.row.isWeight>0">
                  {{ 
                    numberWithCommas(scope.row.isWeight, 2)
                  }}
                </span>
                <span v-else>
                  -
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="isNetbal"
              label="จำนวนเงินรวม"
              align="right"
      
            >
              <template v-slot="scope">
                {{
                  numberWithCommas(scope.row.isNetbal, 2)
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="isNettotal"
              label="ราคาสินค้า"
              align="right"
      
            >
              <template v-slot="scope">
                {{
                  numberWithCommas(scope.row.isNettotal, 2)
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="isVatBal"
              label="VAT 7%"
              align="right"
              width="90"
            >
              <template v-slot="scope">
                {{
                  Number(
                    parseFloat(scope.row.isVatBal).toFixed(2)
                  ).toLocaleString()
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="costPrice"
              label="ราคาทุน"
              align="right"
            >
              <template v-slot="scope">                
                <span v-if="scope.row.costPrice>0">
                 {{
                  numberWithCommas(scope.row.costPrice, 2)
                 }}
                </span>
                <span v-else>
                  -
                </span>
              </template>
            </el-table-column>   
            <el-table-column
              prop="profitPercent"
              label="อัตรากำไร"
              align="right"
              width="90"
            >
              <template v-slot="scope">
                {{
                  scope.row.profitPercent
                }}
              </template>
            </el-table-column>    
            <el-table-column
              prop="profitTotal"
              label="ค่าดำเนินการ(กำไร)"
              align="right"
            >
              <template v-slot="scope">
                <span v-if="scope.row.profitTotal>0">
                 {{
                  numberWithCommas(scope.row.profitTotal, 2)
                 }}
                </span>
                <span v-else>
                  -
                </span>
              </template>
            </el-table-column>      
            <el-table-column
              prop="tax"
              label="ภาษีหัก ณ ที่จ่าย 3%"
              align="right"
            >
              <template v-slot="scope">
                <span v-if="scope.row.tax>0">
                 {{
                  numberWithCommas(scope.row.tax, 2)
                 }}
                </span>
                <span v-else>
                  -
                </span>
              </template>
            </el-table-column>  
            <el-table-column
              prop="profitTotalTax"
              label="VAT 7% จากค่าดำเนินการ"
              align="right"
            >
              <template v-slot="scope">
                <span v-if="scope.row.profitTotalTax>0">
                 {{
                  numberWithCommas(scope.row.profitTotalTax, 2)
                 }}
                </span>
                <span v-else>
                  -
                </span>
              </template>
            </el-table-column>            
            <el-table-column
              prop="priceOverDueTotal"
              label="รวมยอดค้างชำระ"
              align="right"

            >
              <template v-slot="scope">
                <span style="color: blue">
                {{
                  numberWithCommas(scope.row.priceOverDueTotal, 2)
                }}                  
                </span>
              </template>
            </el-table-column>        
            <el-table-column
              prop="overDueDate"
              label="กำหนดชำระ"
              align="center"
              width="100"
            >
              <template v-slot="scope">
                <span v-bind:style="{ color: scope.row.isOverdueColor}" v-if="scope.row.iSisPay != 1">
                {{
                  formatDateFromISO(scope.row.overDueDate)
                }}
                </span>
                <span v-bind:style="{ color: scope.row.isOverdueColor}" v-if="scope.row.iSisPay == 1">
                {{
                  "ชำระแล้ว"
                }}
                <br/>
                <span style="font-size: 12px; color: #a1a5b7">{{ formatDateFromISO(scope.row.isPayDate) }}</span>
                </span>                
              </template>
            </el-table-column>    
            <role-view :roles="['user', 'manager', 'owner']">     
              <el-table-column
                :selectable="selectable"
                type="selection"
                width="55"
                align="center"
              ></el-table-column> 
            </role-view>                                       
          </el-table>
          <br/>
          <span class="fw-bolder" style="font-size: 12px; color: red"> *** </span><span class="fw-bolder" style="font-size: 12px; color: #7e8299;  font-weight: 800 !important;"> [QT] </span> <span class="fw-bolder" style="font-size: 12px; color: red"> คือ รายการใบเสนอราคา </span>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/ApiService";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
// import Status from "../../components/status/Status.vue";
import { numberWithCommas, formatDateFromISO } from "@/utils";
import RoleView from '../../components/RoleView.vue';
import { validateRole, role } from "@/helpers/role"
import DateTimePickerWithOption from '../../components/forms/DateTimePickerWithOption.vue';
import { DateTime } from 'luxon'
// import DownloadExcel from 'vue-json-to-excel';
import DownloadExcel from '@/components/files/ExportExcel';

export default {
  mounted: function () {
    setCurrentPageBreadcrumbs("รายงานค้างชำระเงิน", []);

    const start = new Date();
    const end = new Date();
    // start.setMonth(start.getMonth() - 1);
    // this.SelectedMonthValue = [start, end];

    // this.startMonth = new Date(
    //   new Date(
    //     this.SelectedMonthValue[0].getFullYear(),
    //     this.SelectedMonthValue[0].getMonth(),
    //     1
    //   ).setDate(
    //     new Date(
    //       this.SelectedMonthValue[0].getFullYear(),
    //       this.SelectedMonthValue[0].getMonth(),
    //       1
    //     ).getDate() + 1
    //   )
    // )
    //   .toISOString()
    //   .split("T")[0];
    // this.endMonth = new Date(
    //   new Date(
    //     this.SelectedMonthValue[1].getFullYear(),
    //     this.SelectedMonthValue[1].getMonth() + 1,
    //     0
    //   ).setDate(
    //     new Date(
    //       this.SelectedMonthValue[1].getFullYear(),
    //       this.SelectedMonthValue[1].getMonth() + 1,
    //       0
    //     ).getDate() + 1
    //   )
    // )
    //   .toISOString()
    //   .split("T")[0];
    const curr = new Date; // get current date
    let first = curr.getDate() + 1 - curr.getDay() - 7; // First day is the day of the month - the day of the week

    this.startWeek = new Date(curr.setDate(first));
    this.endWeek = new Date(curr.setDate(curr.getDate() + 6));

    this.searchPartner("");

    if(validateRole(role.admin)){
      this.filter.partnerCode = null;
    }
    else
    {
      this.filter.partnerCode = this.$selectedPartnerCode;
		  var now = new Date().getTime();
		  this.excelFileName = 'Export_'+now;     
      this.excelTitleSheet = 'วันที่ : ' + DateTime.fromJSDate (this.filter.dateRange[0]).toFormat('dd/MM/yyyy') + ' -' + DateTime.fromJSDate (this.filter.dateRange[1]).toFormat('dd/MM/yyyy');      
    }
    
    this.getSellOrderReportHead(this.startWeek, this.endWeek);            
  },
  components: {
    RoleView,
    DateTimePickerWithOption,
    DownloadExcel,
  }, 
  computed: { 
    isAdmin() {
      return validateRole(role.admin)
    },    
    showDueTotal(){
      return this.multipleSelection.reduce((acc, curr) => acc + this.sumDueTotal(curr), 0);
    },
    btnExcelClass() {
      return this.sellreportHead.length==0 ? "btn btn-light-success btn-md py-3 px-5 me-3 disabled" : "btn btn-light-success btn-md py-3 px-5 me-3";
    },
    btnExcelStyle() {
      return this.sellreportHead.length==0 ? "pointer-events:none;" : "";
    }    
  },    
  methods: {
    numberWithCommas,
    formatDateFromISO,
    setDataTolocalStorage: function () {
      localStorage.setItem("startDate", this.filter.dateRange[0]);
      localStorage.setItem("endDate", this.filter.dateRange[1]);
    },
    getSellOrderReportHeadByDate: function (e) {
      // this.startMonth = new Date(
      //   new Date(
      //     this.SelectedMonthValue[0].getFullYear(),
      //     this.SelectedMonthValue[0].getMonth(),
      //     1
      //   ).setDate(
      //     new Date(
      //       this.SelectedMonthValue[0].getFullYear(),
      //       this.SelectedMonthValue[0].getMonth(),
      //       1
      //     ).getDate() + 1
      //   )
      // )
      //   .toISOString()
      //   .split("T")[0];
      // this.endMonth = new Date(
      //   new Date(
      //     this.SelectedMonthValue[1].getFullYear(),
      //     this.SelectedMonthValue[1].getMonth() + 1,
      //     0
      //   ).setDate(
      //     new Date(
      //       this.SelectedMonthValue[1].getFullYear(),
      //       this.SelectedMonthValue[1].getMonth() + 1,
      //       0
      //     ).getDate() + 1
      //   )
      // )
      //   .toISOString()
      //   .split("T")[0];
      const curr = new Date; // get current date
      let first = curr.getDate() + 1 - curr.getDay() - 7; // First day is the day of the month - the day of the week

      this.startWeek = new Date(curr.setDate(first));
      this.endWeek = new Date(curr.setDate(curr.getDate() + 6));

      this.getSellOrderReportHead(this.startWeek, this.endWeek); 
    },
    handleSelectionChangeHead(val) {
      this.SelectedHeadID = val.columnKey;
      this.getSellOrderReportDetail();
      this.isDisabledButton = val.isPay == 1 ? true : false;
    },
    SelectedRowClassName({ row, rowIndex }) {
      if (row.columnKey === this.SelectedHeadID) {
        return "selected-row";
      }
      return "";
    },
    getSummaryHead(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "รวม";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });

      sums.forEach((column, index) => {
        if (index === 1 || index === 2) {
          sums[index] = Number(
            numberWithCommas(sums[index], 2)
          ).toLocaleString();
        }
      });

      return sums;
    },
    getSummaryDetail(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'รวม ' + data.length + ' รายการ';
          return;
        }
        
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });

      sums.forEach((column, index) => {
        if (
          index === 1 ||
          index === 2 ||
          index === 3 ||
          index === 4 ||
          index === 5 ||
          index === 7 ||
          index === 8 ||
          index === 9 ||
          index === 10
          
        ) {
          sums[index] = Number(
            parseFloat(sums[index]).toFixed(2)
          ).toLocaleString();
        }
      });

      return sums;
    },
    getSellOrderReportHead: async function (start, end) {
      try {
        this.loadingHead = true;
        this.SelectedHeadID = 0;
        this.sellreportHead = [];
        // this.sellreportDetail = [];

        if(this.filter.status == "ค้างชำระ"){
          this.statusSelected = 0;
          this.isPayFilter = false;
          this.isCheckDisabled = true;
        }
        else if(this.filter.status == "ชำระแล้ว")
        {
          this.statusSelected = 1;
          this.isCheckDisabled = false;
        }
        else
        {
          this.statusSelected = 3;
          this.isCheckDisabled = false;
        }

        const { data } = await ApiService.query(
          "sellorder/GetOverdueReportHead?Start=" +
            DateTime.fromJSDate (this.filter.dateRange[0]).toFormat('yyyy-MM-dd') +
            "&End=" +
            DateTime.fromJSDate (this.filter.dateRange[1]).toFormat('yyyy-MM-dd') +
            "&Status=" +
            this.statusSelected +
            "&PartnerCode=" +
            this.filter.partnerCode +
            "&PayStart=" +
            DateTime.fromJSDate (this.filter.payDateRange[0]).toFormat('yyyy-MM-dd') +
            "&PayEnd=" +
            DateTime.fromJSDate (this.filter.payDateRange[1]).toFormat('yyyy-MM-dd') +
            "&IsPayFilter=" +
            this.isPayFilter
        );
        
        this.sellreportHead = data;
        localStorage.removeItem("startDate");
        localStorage.removeItem("endDate");
        // window.location.reload();
      } catch (error) {
        console.log(error);
      }

      if(validateRole(role.admin))
      {
		    var now = new Date().getTime();
		    this.excelFileName = validateRole(role.admin) && this.filter.partnerCode != "" ? 'Export_'+this.filter.partnerCode+'_'+now : 'Export_'+now;     
        this.excelTitleSheet = 'วันที่ : ' + DateTime.fromJSDate (this.filter.dateRange[0]).toFormat('dd/MM/yyyy') + ' -' + DateTime.fromJSDate (this.filter.dateRange[1]).toFormat('dd/MM/yyyy');        
      }     

      this.loadingHead = false;
    },
    getSellOrderReportDetail: async function () {
      try {
        this.loadingDetail = true;
        this.sellreportDetail = [];
        const { data } = await ApiService.query(
          "sellorder/GetOverdueReportDetail?key=" +
            this.SelectedHeadID +
            "&start=" +
            DateTime.fromJSDate (this.filter.dateRange[0]).toFormat('yyyy-MM-dd') +
            "&end=" +
            DateTime.fromJSDate (this.filter.dateRange[1]).toFormat('yyyy-MM-dd')
        );
        this.sellreportDetail = data;
      } catch (error) {
        console.log(error);
      }
      this.loadingDetail = false;
    },
    getHeadData() {
      // this.startMonth = new Date(
      //   new Date(
      //     this.SelectedMonthValue[0].getFullYear(),
      //     this.SelectedMonthValue[0].getMonth(),
      //     1
      //   ).setDate(
      //     new Date(
      //       this.SelectedMonthValue[0].getFullYear(),
      //       this.SelectedMonthValue[0].getMonth(),
      //       1
      //     ).getDate() + 1
      //   )
      // )
      //   .toISOString()
      //   .split("T")[0];
      // this.endMonth = new Date(
      //   new Date(
      //     this.SelectedMonthValue[1].getFullYear(),
      //     this.SelectedMonthValue[1].getMonth() + 1,
      //     0
      //   ).setDate(
      //     new Date(
      //       this.SelectedMonthValue[1].getFullYear(),
      //       this.SelectedMonthValue[1].getMonth() + 1,
      //       0
      //     ).getDate() + 1
      //   )
      // )
      //   .toISOString()
      //   .split("T")[0];
      const curr = new Date; // get current date
      let first = curr.getDate() + 1 - curr.getDay() - 7; // First day is the day of the month - the day of the week

      this.startWeek = new Date(curr.setDate(first));
      this.endWeek = new Date(curr.setDate(curr.getDate() + 6));
      this.getSellOrderReportHead(this.startWeek, this.endWeek);
    },
    callOverdueItems(){
      if(this.multipleSelection.length > 0){
        //  console.log(this.multipleSelection);
        //  console.log(this.sellreportHead);
        if((this.multipleSelection.filter(val=>val.orderCode.startsWith('SO'))).length>0){

          if((this.sellreportHead.filter(val => val.isCode.startsWith('RD')).length) != (this.multipleSelection.filter(val=>val.isCode.startsWith('RD'))).length ){
            this.$message({
              type: "warning",
              message: "กรุณาเลือกรายการใบรับมัดจำ(RD) เพื่อชำระเงินในรอบบิลนี้ทั้งหมด",
            });
            // return;
          }else{
            this.setDataTolocalStorage();
            this.$router.push({ name: "overdueItems", query: { inv: this.multipleSelection.map((v) => v.isCode) }, });
          }

        }else{
            this.$message({
              type: "warning",
              message: "กรุณาเลือกรายการบิลขาย อย่างน้อย 1 รายการ",
            });
        }


      }else{
          this.$message({
            type: "warning",
            message: "กรุณาเลือกรายการที่ต้องการชำระ",
          });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },  
    handleRowChange(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },      
    sumDueTotal(item){
      const { priceOverDueTotal } = item;
      return (
        (isNaN(priceOverDueTotal) ? 0 : priceOverDueTotal)
      );      
    },
    selectable(row, index) {
      if (row.iSisPay === false) {
        return true;
      } else {
        return false;
      }
    }, 
    searchPartner: async function(query)
    {
      this.searchingPartner = true;
      const {data} = await ApiService.query("data-options/partners", {query})
      this.arrPartnerOption = data
      this.searchingPartner = false;
    },       
  },
  data() {
    return {
      windowHeight: window.innerHeight - 230,
      multipleSelection: [],
      isDisabledButton: true,
      sellreportHead: [],
      sellreportDetail: [],
      SelectedHeadID: 0,
      loadingHead: false,
      loadingDetail: false,
      startMonth: "",
      endMonth: "",
      startWeek: "",
      endWeek: "",
      SelectedMonthValue: [],
      statusSelected: null,
      textDueTotal: 0,
      arrPartnerOption: [],
      isPayFilter: false,
      isCheckDisabled: true,
      searchingPartner: false,
      status: [
        { value: "ทั้งหมด", name: 'ทั้งหมด'},
        { value: "ค้างชำระ", name: 'ค้างชำระ'},
        { value: "ชำระแล้ว", name: 'ชำระแล้ว'},   
      ],    
      filter: {
        status: "ค้างชำระ",
        partnerCode: "",
        dateRange: [],
        payDateRange: [],
      },      
      shortcuts: [
        {
          text: "เดือนนี้",
          value: [new Date(), new Date()],
        },
        {
          text: "เดือนที่แล้ว",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 1);
            end.setMonth(end.getMonth() - 1);
            return [start, end];
          })(),
        },
        {
          text: "6 เดือนที่แล้ว",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            return [start, end];
          })(),
        },
        {
          text: "ปีนี้",
          value: (() => {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            return [start, end];
          })(),
        },
      ],
      currentDate : null,
      excelTitleSheet: "", 
      excelFileName: "",
      excelParam: ["iS_Date","isCode","isWeight","isNetbal","isNettotal","isVatBal","costPrice","profitPercent","profitTotal","tax","profitTotalTax","priceOverDueTotal","overDueDate"],        
			excelColumnName: [
        { "name" : "iS_Date" , "value" : "วันที", "colspan" : "1", "type" : "DateTime" },
				{ "name" : "isCode" , "value" : "ใบกำกับภาษี", "colspan" : "2", "type" : "String" },
				{ "name" : "isWeight" , "value" : "น้ำหนัก", "colspan" : "1", "type" : "Number" },
				{ "name" : "isNetbal" , "value" : "จำนวนเงินรวม", "colspan" : "2", "type" : "Number" },
				{ "name" : "isNettotal" , "value" : "ราคาสินค้า", "colspan" : "2", "type" : "Number" },
				{ "name" : "isVatBal" , "value" : "VAT 7%", "colspan" : "1", "type" : "Number" },
        { "name" : "costPrice" , "value" : "ราคาทุน", "colspan" : "2", "type" : "Number" },
        { "name" : "profitPercent" , "value" : "อัตรากำไร", "colspan" : "1", "type" : "String" },
        { "name" : "profitTotal" , "value" : "ค่าดำเนินการ(กำไร)", "colspan" : "2", "type" : "Number" },
        { "name" : "tax" , "value" : "ภาษีหัก ณ ที่จ่าย 3%", "colspan" : "2", "type" : "Number" },
        { "name" : "profitTotalTax" , "value" : "vat 7% จากค่าดำเนินการ", "colspan" : "2", "type" : "Number" },
        { "name" : "priceOverDueTotal" , "value" : "รวมยอดค้างชำระ", "colspan" : "2", "type" : "Number" },
        { "name" : "overDueDate" , "value" : "กำหนดชำระ", "colspan" : "1", "type" : "DateTime" },
			],         
      excelMeta: [
        [{
          "key": "charset",
          "value": "utf-8"
        }]
      ],      
    };
  },
  created() {
    // var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    // this.filter.dateRange[0] = new Date(y, m, 1)
    // this.filter.dateRange[1] = new Date(y, m + 1, 0)

    // console.log("window.localStorage.getItem('startDate')",window.localStorage.getItem('startDate'));
    const curr = new Date; // get current date
    let first = curr.getDate() + 1 - curr.getDay() - 7; // First day is the day of the month - the day of the week
    if(window.localStorage.getItem('startDate') && window.localStorage.getItem('endDate')){
        this.filter.dateRange[0] = new Date(window.localStorage.getItem('startDate'));
        this.filter.dateRange[1] = new Date(window.localStorage.getItem('endDate'));
        this.filter.payDateRange[0] = new Date();
        this.filter.payDateRange[1] = new Date();

        // localStorage.removeItem("startDate");
        // localStorage.removeItem("endDate");
        // window.location.reload();
    }else{
      this.filter.dateRange[0] = new Date(curr.setDate(first));
      this.filter.dateRange[1] = new Date(curr.setDate(curr.getDate() + 6));
      this.filter.payDateRange[0] = new Date();
      this.filter.payDateRange[1] = new Date();      
    }
   
  },  
};
</script>
